import { patchAppInfo } from "./appInfo";
import { type I18n, initI18n } from "./lib/i18n";
import { Common } from "./types";

export const initCommon = (info: Common.AppInfo, i18n: I18n) => {
  patchAppInfo(info);
  initI18n(i18n);
};
